import { LOCAL_STORAGE_KEY } from '../../application/configuration'

export const setToStorage = (key: string, data: any) => {
  return localStorage.setItem(key, JSON.stringify(data))
}

export const getFromStorage = (key: string) => {
  const item = localStorage.getItem(key)
  if (item) return JSON.parse(item)
  return
}

class LocalStorage {
  data: Record<string, any>

  constructor() {
    const item = localStorage.getItem(LOCAL_STORAGE_KEY)
    if (item) {
      this.data = JSON.parse(item) || {}
    } else {
      this.data = {}
    }
  }

  get(path: string): any {
    const parts = path.split('.')
    const obj = this.data

    const value = parts.reduce((obj, part) => {
      if (typeof obj !== 'object') throw new Error('invalid path for local storage')
      return obj[part]
    }, obj)

    return value
  }

  set(path: string, value: any) {
    const parts = path.split('.')
    let obj = { ...this.data }
    let lastObj = obj
    parts.forEach((part, index) => {
      lastObj[part] = index === parts.length - 1 ? value : { ...lastObj[part] }
      lastObj = lastObj[part]
    })

    this.data = obj
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(this.data))
  }
}

export const storage = new LocalStorage()
